import React from "react";
import styled from "styled-components";

const HideLongTextStyle = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  height: auto;
  white-space: nowrap;
`;

interface SntHideLongTextProps {
  text?: string;
  children?: React.ReactNode;
  className?: string;
  [key: string]: unknown;
}

const SntHideLongText = (props: SntHideLongTextProps) => {
  const { text, children, className, ...rest } = { ...props };
  return (
    <HideLongTextStyle className={className} title={text || ""} {...rest}>
      {children || text}
    </HideLongTextStyle>
  );
};
export default SntHideLongText;
